import { useTranslation } from 'react-i18next';
import { usePlatform } from 'core/hooks/platform';
import { Button } from '../../../buttons/button';
import styles from '../../popup.module.scss';

function InstructionsCard({
  icon,
  title,
  description,
  buttonText,
  action,
}: {
  icon: string;
  title: string;
  description: string;
  buttonText: string;
  action: () => void;
}) {
  const { t } = useTranslation();
  const { translate } = usePlatform();

  return (
    <div className={`row align-items-center justify-content-between ${styles.instructionsCard}`}>
      <i className={`${icon} col-md-2`} />
      <div className="col-md-10 row align-items-center justify-content-between">
        <div className="col-12 col-sm-8">
          <h5>{t(title)}</h5>
          <p className="text-regular">{translate(description)}</p>
        </div>
        <Button classes={['col-12, col-sm-4']} meta={{ title: t(buttonText) }} onClick={action} />
      </div>
    </div>
  );
}

export default InstructionsCard;